<script lang="ts">
import {defineComponent} from 'vue';
import { useI18n } from 'vue-i18n'
export default defineComponent({
    name: 'RenderHeader',
    props: {
        render: Function,
        column: {
            type: Object,
            default: null
        }
    },
    render(ctx: any) {
        const { t } = useI18n()
        if (ctx?.column?.hasTranslate === 1) {
            return ctx.render(ctx?.column);
        }
        return t(ctx.render(ctx?.column));
    }
});
</script>
